import { configureComposer } from '@/features/compose';
import { useEffect } from 'react';
import { usePreferences } from './state/preferences';

/**
 * Hands the composer the one setting it is not allowed to read for itself:
 * how long a sent message may be taken back. The feature owns composing, the
 * application owns preferences, and this is where the two meet (ADR 0006).
 */
export function ComposerSettingsBridge() {
  const undoSendSeconds = usePreferences((state) => state.undoSendSeconds);

  useEffect(() => {
    configureComposer({ undoSendSeconds });
  }, [undoSendSeconds]);

  return null;
}
